(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smylume-match-quiz"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if(root.dataset.ready) return;
    root.dataset.ready='true';
    const dialog=root.querySelector('dialog'), steps=[...root.querySelectorAll('.smq-step')], back=root.querySelector('.smq-back');
    let step=0, autoTimer, selectedBundle="single";
    const preferenceKey='smylume-match-quiz-seen';
    const arrivalKey='smylume-match-quiz-arrival';
    const remember=()=>{
      window.smylumeMatchQuizSeen=true;
      clearTimeout(autoTimer);
      try{localStorage.setItem(preferenceKey,'1');}catch{}
      try{sessionStorage.setItem(preferenceKey,'1');}catch{}
      document.cookie=preferenceKey+'=1; Max-Age=34560000; Path=/; SameSite=Lax; Secure';
    };
    const seen=()=>{
      if(window.smylumeMatchQuizSeen)return true;
      try{if(localStorage.getItem(preferenceKey)==='1')return true;}catch{}
      if(document.cookie.split(';').some(c=>c.trim()===preferenceKey+'=1'))return true;
      try{if(sessionStorage.getItem(preferenceKey)==='1')return true;}catch{}
      return false;
    };
    const show=(n)=>{
      step=n;
      steps.forEach((s,i)=>s.hidden=i!==n);
      back.hidden=n===0;
      root.querySelector('.smq-skip').hidden=n===3;
      root.querySelectorAll('.smq-progress i').forEach((p,i)=>p.classList.toggle('active',i<=n));
      if(dialog.open)steps[n].querySelector('input')?.focus();
    };
    const open=()=>{if(!dialog.open){dialog.showModal();remember();show(step);}};
    const goToMatch=(bundle)=>{
      let url;
      try{
        url=new URL(root.dataset.kitUrl,location.origin);
        url.searchParams.set('kit',bundle==='double'?'complete':'starter');
        url.searchParams.set('variant',bundle==='double'?'67600586998050':'67600586866978');
        if(url.origin!==location.origin)return;
      }catch{return;}
      remember();
      window.location.assign(url.href);
    };
    const launcher=root.querySelector('.smq-launch');
    const launcherTimer=setTimeout(()=>{if(root.isConnected)launcher.hidden=false;},Math.max(0,10000-performance.now()));
    launcher.addEventListener('click',open);
    root.querySelector('.smq-skip').addEventListener('click',()=>{remember();dialog.close();});
    dialog.addEventListener('close',remember);
    dialog.addEventListener('cancel',remember);
    root.querySelector('.smq-close').addEventListener('click',()=>{remember();dialog.close();});
    dialog.addEventListener('click',e=>{
      if(e.target===dialog){
        const r=dialog.getBoundingClientRect();
        if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();
      }
    });
    const updateEmailDestination=()=>{
      const destination=new URL(root.dataset.kitUrl,location.origin);
      destination.searchParams.set('kit',selectedBundle==='double'?'complete':'starter');
      destination.searchParams.set('variant',selectedBundle==='double'?'67600586998050':'67600586866978');
      if(destination.origin!==location.origin)return;
      root.querySelector('.smq-return').value=destination.pathname+destination.search+'#choose-kit';
      root.querySelector('.smq-tags').value='newsletter,smylume-match-quiz,'+(selectedBundle==='double'?'quiz-complete':'quiz-starter');
    };
    root.querySelector('.smq-email-form').addEventListener('submit',()=>{updateEmailDestination();remember();});
    steps.forEach((s,i)=>s.addEventListener('change',e=>{
      if(!e.target.matches('input[type="radio"]'))return;
      if(i===2){
        selectedBundle=e.target.dataset.bundle==='double'?'double':'single';
        try{sessionStorage.setItem('smylume-match-bundle',selectedBundle);}catch{}
        updateEmailDestination();
        show(3);
      }
      else show(i+1);
    }));
    back.addEventListener('click',()=>{
      const previous=Math.max(0,step-1);
      steps[previous].querySelectorAll('input').forEach(input=>input.checked=false);
      show(previous);
    });
    show(0);
    if(root.querySelector('[data-quiz-errors]')){
      try{selectedBundle=sessionStorage.getItem('smylume-match-bundle')==='double'?'double':'single';}catch{}
      updateEmailDestination();
      show(3);
      dialog.showModal();
    }
    if(root.dataset.auto==='true'&&!seen()&&!window.Shopify?.designMode){
      let arrival=Date.now();
      try{
        const saved=Number(sessionStorage.getItem(arrivalKey));
        if(saved>0&&saved<=arrival)arrival=saved;
        else sessionStorage.setItem(arrivalKey,String(arrival));
      }catch{}
      const delay=(Number(root.dataset.delay)||20)*1000;
      autoTimer=setTimeout(()=>{
        if(!seen()&&root.isConnected&&!document.querySelector('cart-drawer.active, dialog[open]'))open();
      },Math.max(0,delay-(Date.now()-arrival)));
    }
    window.addEventListener('pagehide',()=>{clearTimeout(autoTimer);clearTimeout(launcherTimer);},{once:true});
  }
  document.querySelectorAll('.smq').forEach(init);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.smq').forEach(init));
})();

  } catch(e) { console.error(e); }
})();
})();
